export enum WindowBreakpoints {
  small = 575,
  medium = 767,
  large = 991,
  xlarge = 1106,
  xxLarge = 1162,
  xxxLarge = 1499,
  xxxxLarge = 1618,
  modalPageView = 1050,
}
